// import { getColor } from '@mui/material/styles';

// import breakpoints from 'utils/breakpoints';
import { getColor } from 'utils/colors';

// import mixins from 'utils/mixins';
// import { remCalc } from 'utils/remCalc';

// const theme = createTheme({
// 	breakpoints: breakpoints,
// 	mixins: mixins,
// });

export const styles = {};

export const overrides = {
	'.neighborhoodDetails': {
		'.neighborhoodDetails__description': {
			textAlign: 'center',
			margin: '0 auto 0',
			fontStyle: 'italic',
			color: getColor('ivory', 600),
		},
		'.neighborhoodDetails__introTitle': {
			textAlign: 'center',
			margin: '40px auto',
			textTransform: 'uppercase',
		}
	}
};

export default styles;